import Loging from './pages/Login/Login.vue'
import CheckAcceptCode from './pages/Login/CheckAcceptCode.vue'
import AdminPanel from './pages/AdminPanel/AdminPanel.vue'
import BlockIP from './pages/BlockIP/BlockIP.vue'
import RecoveryPassword from './pages/RecoveryPassword/RecoveryPassword.vue'
import LoginByMobile from './pages/LoginByMobile/LoginByMobile.vue'

export const appRoutes = [
    {
        path: "*",
        component: Loging,
        // name: "*"
    },
    {
        path: "/",
        component: Loging,
        // name: "/"
    },
    {
        path: "/Login",
        component: Loging,
        // name: "Login"
    },
    {
        path: "/AdminPanel",
        component: AdminPanel,
        // name: "AdminPanel"
    },
    {
        path: "/BlockIP",
        component: BlockIP,
        // name: "BlockIP"
    },
    {
        path: "/RecoveryPassword",
        component: RecoveryPassword
    },
    {
        path: "/LoginByMobile",
        component: LoginByMobile
    },
    {
        path: "/CheckAcceptCode",
        component: CheckAcceptCode
    }
];


// WEBPACK FOOTER //
// ./src/Routes.js